(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    (function(){var root=document.querySelector('.pp-announcement');if(!root)return;var copy=root.querySelector('.pp-a-copy'),i=0,msg=['Livraison <strong>GRATUITE</strong>','Livraison suivie sous <strong>11 jours</strong>','Retour possible sous <strong>14 jours</strong>'];function show(n){i=(n+msg.length)%msg.length;copy.innerHTML=msg[i]}root.querySelector('.pp-a-prev').onclick=function(){show(i-1)};root.querySelector('.pp-a-next').onclick=function(){show(i+1)};setInterval(function(){show(i+1)},4500)})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-main"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.ppCartEventsBound)return;
  window.ppCartEventsBound=true;
  var busy=false;
  function page(){return document.querySelector('[data-cart-section]');}
  function status(message,error){var root=page();if(!root)return;var node=root.querySelector('.pp-cart-status');node.textContent=message;node.hidden=!message;node.classList.toggle('is-error',!!error);}
  function lock(value){busy=value;var root=page();if(!root)return;root.setAttribute('aria-busy',String(value));root.querySelectorAll('[data-cart-step],[data-cart-remove],[data-cart-quantity]').forEach(function(node){node.disabled=value;});var checkout=root.querySelector('.td-cart-checkout-btn');if(checkout)checkout.setAttribute('aria-disabled',String(value));}
  function badge(count){document.querySelectorAll('.pp-cart-link').forEach(function(link){var node=link.querySelector('span');if(count>0){if(!node){node=document.createElement('span');link.appendChild(node);}node.textContent=count;}else if(node)node.remove();});}
  async function renderCart(cart,root,focus){
    var id=root.dataset.cartSection,html=cart.sections&&cart.sections[id];
    if(!html){var url=new URL(window.location.href);url.searchParams.delete('sections');url.searchParams.set('section_id',id);var response=await fetch(url,{headers:{Accept:'text/html'}});if(!response.ok)throw new Error(root.dataset.cartError);html=await response.text();}
    var next=new DOMParser().parseFromString(html,'text/html').querySelector('[data-cart-section]');
    if(!next)throw new Error(root.dataset.cartError);
    root.replaceWith(next);badge(cart.item_count);
    if(focus){var row=Array.from(next.querySelectorAll('[data-key]')).find(function(node){return node.dataset.key===focus.key;});var target=row&&(focus.step?row.querySelector('[data-cart-step="'+focus.step+'"]'):row.querySelector('[data-cart-quantity]'));if(!target)target=next.querySelector('.td-cart-title,.td-cart-empty h1');if(target){if(!target.matches('input,button'))target.tabIndex=-1;target.focus({preventScroll:true});}}
  }
  async function update(payload,endpoint,focus){
    if(busy)return;
    var root=page();if(!root)return;
    lock(true);status(root.dataset.cartUpdating,false);
    payload.sections=[root.dataset.cartSection];payload.sections_url=window.location.pathname+window.location.search;
    try{
      var response=await fetch(endpoint,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)});
      var cart=await response.json();
      if(!response.ok)throw new Error(typeof cart.description==='string'?cart.description:root.dataset.cartError);
      await renderCart(cart,root,focus);status(page().dataset.cartUpdated,false);
    }catch(error){
      try{var recovery=await fetch(root.dataset.cartUrl+'.js',{headers:{Accept:'application/json'}});if(recovery.ok)await renderCart(await recovery.json(),page(),focus);}catch(ignored){}
      var current=page();current.querySelectorAll('[data-cart-quantity]').forEach(function(input){input.value=input.dataset.currentQuantity;});status(error.message||current.dataset.cartError,true);
    }finally{lock(false);}
  }
  function change(input,focus){var qty=Number(input.value);if(input.value.trim()===''||!Number.isSafeInteger(qty)||qty<0){input.value=input.dataset.currentQuantity;return;}if(qty===Number(input.dataset.currentQuantity))return;var root=page(),row=input.closest('[data-key]');update({id:row.dataset.key,quantity:qty},root.dataset.cartChangeUrl,focus||{key:row.dataset.key});}
  document.addEventListener('click',function(event){
    var checkout=event.target.closest('.td-cart-checkout-btn');if(checkout&&busy){event.preventDefault();return;}
    var button=event.target.closest('[data-cart-step],[data-cart-remove]');if(!button||!button.closest('[data-cart-section]'))return;
    event.preventDefault();if(busy)return;
    var row=button.closest('[data-key]'),input=row.querySelector('[data-cart-quantity]');
    var qty=button.hasAttribute('data-cart-remove')?0:Math.max(0,Number(input.dataset.currentQuantity)+Number(button.dataset.cartStep));
    if(qty===Number(input.dataset.currentQuantity))return;
    input.value=qty;change(input,{key:row.dataset.key,step:button.dataset.cartStep});
  });
  document.addEventListener('change',function(event){if(event.target.matches('[data-cart-quantity]')&&!busy)change(event.target);});
  document.addEventListener('keydown',function(event){if(event.target.matches('[data-cart-quantity]')&&event.key==='Enter'){event.preventDefault();if(!busy)change(event.target);}});
  var root=page();
  if(root&&root.dataset.legacyPack==='true'){
    var updates={'59706525221209':1};root.querySelectorAll('[data-key]').forEach(function(row){updates[row.dataset.key]=0;});update({updates:updates},root.dataset.cartUpdateUrl);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pneupret-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('pp-product');
  if(!root)return;
  root.querySelectorAll('.ph-r').forEach(function(el){el.classList.add('in')});
  root.querySelectorAll('.ph-acc details').forEach(function(d){
    d.addEventListener('toggle',function(){
      if(d.open)d.parentElement.querySelectorAll('details').forEach(function(x){if(x!==d)x.open=false});
    });
  });
  var hero=root.querySelector('[data-carousel="hero"]');
  var slides=[].slice.call(root.querySelectorAll('.ph-slide'));
  var thumbs=[].slice.call(root.querySelectorAll('.ph-thumb'));
  var range=root.querySelector('.ph-gallery-bar');
  var idx=0;
  function show(i){
    if(!slides.length)return;
    idx=(i+slides.length)%slides.length;
    slides.forEach(function(slide,n){
      var video=slide.querySelector('video');
      if(video&&n!==idx){try{video.pause()}catch(e){}}
      slide.classList.toggle('active',n===idx);
      slide.setAttribute('aria-hidden',n===idx?'false':'true');
    });
    thumbs.forEach(function(t,n){
      t.classList.toggle('active',n===idx);
      t.setAttribute('aria-pressed',n===idx?'true':'false');
    });
    if(range){
      range.value=idx;
      if(slides[idx]&&slides[idx].dataset.title)range.setAttribute('aria-valuetext',slides[idx].dataset.title);
    }
  }
  root.querySelectorAll('[data-gallery-direction]').forEach(function(button){
    button.addEventListener('click',function(){show(idx+Number(button.dataset.galleryDirection||0))});
  });
  if(range)range.addEventListener('input',function(){show(Number(this.value||0))});
  thumbs.forEach(function(t){t.addEventListener('click',function(){show(Number(t.dataset.index||0))})});
  if(hero){
    var sx=0,sy=0;
    hero.addEventListener('touchstart',function(e){if(e.touches&&e.touches[0]){sx=e.touches[0].clientX;sy=e.touches[0].clientY}},{passive:true});
    hero.addEventListener('touchend',function(e){
      if(!(e.changedTouches&&e.changedTouches[0]))return;
      var dx=e.changedTouches[0].clientX-sx,dy=e.changedTouches[0].clientY-sy;
      if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy))show(idx+(dx<0?1:-1));
    },{passive:true});
    hero.addEventListener('keydown',function(e){
      if(e.target.tagName!=='VIDEO'&&(e.key==='ArrowLeft'||e.key==='ArrowRight')){
        e.preventDefault();show(idx+(e.key==='ArrowRight'?1:-1));
      }
    });
  }
  show(0);
})();

  } catch(e) { console.error(e); }
})();
})();
